/* DAD READY CO. — Patch Edition theme JS (idempotent; re-runs on Shopify editor events) */
(function(){
  const $=(s,c=document)=>c.querySelector(s), $$=(s,c=document)=>[...c.querySelectorAll(s)];
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initHero(sec){
    if(sec.dataset.drInit) return; sec.dataset.drInit='1';
    const imgs=$$('.dr-hat',sec), swatches=$$('.dr-swatch',sec), meta=$('[data-dr-meta]',sec);
    if(!imgs.length) return;
    imgs.forEach((img,i)=>img.classList.toggle('dr-active',i===0));
    function pick(i){
      imgs.forEach(img=>img.classList.toggle('dr-active',img.dataset.hat==i));
      swatches.forEach(b=>b.setAttribute('aria-pressed',b.dataset.hat==i));
      const b=swatches.find(x=>x.dataset.hat==i); if(!b||!meta) return;
      const link=b.dataset.url?`<a href="${b.dataset.url}">${meta.dataset.viewLabel||'View this cap →'}</a>`:'';
      meta.innerHTML=`<strong>${b.dataset.name||''}</strong><span>${b.dataset.price||''}${b.dataset.price&&link?' · ':''}${link}</span>`;
    }
    swatches.forEach(b=>b.addEventListener('click',()=>pick(+b.dataset.hat)));
    if(!reduced && swatches.length>1 && !document.documentElement.classList.contains('shopify-design-mode')){
      const t=setInterval(()=>{const cur=swatches.findIndex(b=>b.getAttribute('aria-pressed')==='true');pick((cur+1)%swatches.length);},4200);
      swatches.forEach(b=>b.addEventListener('click',()=>clearInterval(t),{once:true}));
    }
  }
  function initLineup(sec){
    if(sec.dataset.drInit) return; sec.dataset.drInit='1';
    const filters=$$('.dr-filter',sec), cards=$$('.dr-card',sec);
    filters.forEach(f=>f.addEventListener('click',()=>{
      const cat=f.dataset.filter;
      filters.forEach(x=>x.setAttribute('aria-pressed',x===f));
      cards.forEach(c=>c.classList.toggle('dr-hide',cat!=='all'&&c.dataset.cat!==cat));
    }));
  }
  function initReveals(root){
    const els=$$('.dr-reveal:not(.dr-in)',root);
    if(reduced||!('IntersectionObserver' in window)){els.forEach(e=>e.classList.add('dr-in'));return;}
    const io=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('dr-in');io.unobserve(e.target);}}),{threshold:.12,rootMargin:'0px 0px -6% 0px'});
    els.forEach(el=>io.observe(el));
  }
  function initTilt(root){
    if(!matchMedia('(hover:hover)').matches) return;
    $$('.dr-patch',root).forEach(p=>{
      if(p.dataset.drInit) return; p.dataset.drInit='1';
      const fig=$('figure',p);
      p.addEventListener('mousemove',e=>{const r=p.getBoundingClientRect(),x=(e.clientX-r.left)/r.width-.5,y=(e.clientY-r.top)/r.height-.5;fig.style.transform=`rotateY(${x*18}deg) rotateX(${-y*18}deg) translateZ(14px)`;});
      p.addEventListener('mouseleave',()=>fig.style.transform='');
    });
  }
  function init(root=document){
    $$('[data-dr-hero]',root).forEach(initHero);
    $$('[data-dr-lineup]',root).forEach(initLineup);
    initReveals(root); initTilt(root);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>init()); else init();
  document.addEventListener('shopify:section:load',e=>{ $$('[data-dr-init]',e.target).forEach(x=>delete x.dataset.drInit); init(e.target); });
  document.addEventListener('shopify:block:select',e=>{const b=e.target.closest('.dr-swatch'); if(b) b.click();});
})();
